export default __webpack_public_path__ + "static/media/MYSQL.31245de5.png";